import { FaMapMarkerAlt, FaEnvelope, FaInstagram, FaPhoneAlt } from "react-icons/fa";

function Contact() {
  return (
    <div className="contact-container">
      <h3 className="contact-title">CONNECT WITH US</h3>
      <div className="contact-item">
        <FaPhoneAlt className="contact-icon" />
        <h3 className="contact-title">PHONE</h3>
        <p className="contact-text">+91 9524655853</p>
      </div>

      <div className="contact-item">
        <FaMapMarkerAlt className="contact-icon" />
        <h3 className="contact-title">ADDRESS</h3>
        <p className="contact-text">Velachery, Chennai</p>
      </div>

      <div className="contact-item">
        <FaEnvelope className="contact-icon" />
        <h3 className="contact-title">EMAIL</h3>
        <p className="contact-text">
          <a href="mailto:tagmepics@gmail.com">tagmepics@gmail.com</a>
        </p>
      </div>

      <div className="contact-item">
        <FaInstagram className="contact-icon" />
        <h3 className="contact-title">INSTAGRAM</h3>
        <p className="contact-text">
          <a
            href="https://instagram.com/tagmephotography42"
            target="_blank"
            rel="noopener noreferrer"
          >
            tagmephotography42
          </a>
        </p>
      </div>
    </div>
  );
}

export default Contact;
